module.exports = __webpack_public_path__ + "img/27.fixed_shower.a6b9eba6.svg";